import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { isEqual } from 'lodash-es';
import SlimRelatedProductsCarousel from './SlimRelatedProductsCarousel.vue';
import { isProductAvailableInCountry, isDiscontinued } from '~/composables/useProduct/useProductAvailability';
import { useCartGetters } from '~/composables/_next/cart/useCartGetters';
import { useProduct } from '~/composables/_next/useProduct';
import { PRODUCT_CARDS_CAROUSEL_SLIDES_AMOUNT } from '~/constants';
import { containsNonNullOrNonEmptyObject } from '~/helpers/containsArrayIsNonNull';
import { gtmPushEvent, gtmPriceFormat, cartDiscountPrice, centimesToEuros } from '~/helpers/gtm';
import { getIsNewProduct } from '~/helpers/productCardMethods';
import { useLocalization } from '~/composables/_next/useLocalization';
import useRightPath from '~/composables/useRightPath';
import { filterProducts } from '~/utils/commercetools/products';
export default /*#__PURE__*/_defineComponent({
  __name: 'SlimRelatedProducts',
  props: {
    productsList: {
      type: Object,
      default: null
    },
    attraqtData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var _useProduct = useProduct('slimAssociatedProducts'),
      productsAssociated = _useProduct.products,
      searchProductsAssociated = _useProduct.search;
    var _useCartGetters = useCartGetters(),
      getItemPrice = _useCartGetters.getItemPrice;
    var _useLocalization = useLocalization(),
      country = _useLocalization.country;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var pageUrl = route.fullPath;
    var listOfProducts = computed(function () {
      var _props$productsList, _props$productsList$l;
      return (_props$productsList = props.productsList) === null || _props$productsList === void 0 ? void 0 : (_props$productsList$l = _props$productsList.listOfProducts) === null || _props$productsList$l === void 0 ? void 0 : _props$productsList$l.slice(0, PRODUCT_CARDS_CAROUSEL_SLIDES_AMOUNT);
    });
    var relatedProducts = computed(function () {
      var nonMasterVariants = filterNonMasterVariants(productsAssociated.value);
      var masterProductsWithVariants = filterMasterProductsWithVariants(productsAssociated.value, nonMasterVariants);
      return sortProductsBySku(masterProductsWithVariants, listOfProducts.value) || '';
    });
    function filterNonMasterVariants(products) {
      return filterProducts(products, {
        master: false
      }).filter(function (product) {
        return isProductAvailableInCountry(product, country);
      });
    }
    function filterMasterProductsWithVariants(products, nonMasterVariants) {
      var filteredProducts = [];
      var _iterator = _createForOfIteratorHelper(filterProducts(products, {
          master: true
        })),
        _step;
      try {
        var _loop = function _loop() {
          var product = _step.value;
          if (!isProductAvailableInCountry(product, country)) return 1; // continue
          var variants = nonMasterVariants.filter(function (variant) {
            return variant._id === product._id && !variant._master;
          });
          var productWithVariants = _objectSpread(_objectSpread({}, product), {}, {
            variants: variants
          });
          if (productHasSellableVariants(productWithVariants)) {
            filteredProducts.push(productWithVariants);
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          if (_loop()) continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return filteredProducts;
    }
    function productHasSellableVariants(product) {
      var _product$variants;
      if (!((_product$variants = product.variants) !== null && _product$variants !== void 0 && _product$variants.length)) return true;
      return !product.variants.every(function (variant) {
        return isDiscontinued(variant);
      });
    }
    function sortProductsBySku(products, skuList) {
      return products.filter(function (product) {
        return getProductPath(product);
      }).sort(function (a, b) {
        return (skuList === null || skuList === void 0 ? void 0 : skuList.indexOf(a.sku)) - (skuList === null || skuList === void 0 ? void 0 : skuList.indexOf(b.sku));
      });
    }
    var searchProductsByListSku = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!containsNonNullOrNonEmptyObject(listOfProducts.value)) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return searchProductsAssociated({
                skus: listOfProducts.value
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function searchProductsByListSku() {
        return _ref.apply(this, arguments);
      };
    }();
    var _useLazyAsyncData = useLazyAsyncData('component-organism-slimRelatedProducts', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (listOfProducts.value) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", true);
            case 2:
              _context2.next = 4;
              return searchProductsByListSku();
            case 4:
              return _context2.abrupt("return", _context2.sent);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })), {
        watch: [listOfProducts]
      }),
      error = _useLazyAsyncData.error;
    watch(error, function () {
      console.error('failed while search related products', error);
    });
    watch(relatedProducts, function (newValue, oldValue) {
      if (!isEqual(newValue, oldValue) && newValue.length > 0) {
        var _props$attraqtData;
        var gtmUpsellItems = newValue.map(function (item) {
          var _getItemPrice = getItemPrice(item),
            regular = _getItemPrice.regular,
            special = _getItemPrice.special;
          var discountPrice = cartDiscountPrice({
            regular: regular,
            quantity: item.quantity
          }, special);
          return {
            item_id: "SKU_".concat(item.sku),
            item_sku: item.sku,
            item_name: item._name,
            discount: discountPrice ? gtmPriceFormat(discountPrice) : '',
            discount_in_cents: discountPrice ? gtmPriceFormat(discountPrice, true) : '',
            new_product: getIsNewProduct(item),
            quantity: item.quantity || 1,
            price: centimesToEuros(item.price.value.centAmount),
            price_in_cents: gtmPriceFormat(item.price.value.centAmount),
            currency: item.price.value.currencyCode
          };
        });
        gtmPushEvent('slim_upsell_product', {
          event_category: 'ecommerce',
          event_action: 'page_load',
          event_label: 'upsell_product',
          event_name: 'upsell_product',
          page_url: pageUrl,
          ecommerce: {
            is_attraqt_upsell_products: !!(props !== null && props !== void 0 && (_props$attraqtData = props.attraqtData) !== null && _props$attraqtData !== void 0 && _props$attraqtData.id),
            title_of_the_block: props.productsList.title,
            items: gtmUpsellItems
          }
        });
      }
    }, {
      immediate: true
    });
    return {
      __sfc: true,
      props: props,
      route: route,
      productsAssociated: productsAssociated,
      searchProductsAssociated: searchProductsAssociated,
      getItemPrice: getItemPrice,
      country: country,
      getProductPath: getProductPath,
      pageUrl: pageUrl,
      listOfProducts: listOfProducts,
      relatedProducts: relatedProducts,
      filterNonMasterVariants: filterNonMasterVariants,
      filterMasterProductsWithVariants: filterMasterProductsWithVariants,
      productHasSellableVariants: productHasSellableVariants,
      sortProductsBySku: sortProductsBySku,
      searchProductsByListSku: searchProductsByListSku,
      error: error,
      SlimRelatedProductsCarousel: SlimRelatedProductsCarousel
    };
  }
});